import {
  MenuButton,
  Center,
  Avatar,
  AvatarBadge,
  MenuList,
  MenuGroup,
  MenuItem,
  Flex,
  Text,
  Heading,
  Menu,
  Skeleton
} from '@chakra-ui/react'
// Direct import: the `lib` barrel also re-exports the `world-countries`
// dataset, and this button renders in the sidebar on every authenticated page,
// so going through the barrel put ~550 KB of country data in the initial bundle.
import { getSocket } from '../../../../lib/websockets'

import React from 'react'
import { VscSignOut } from 'react-icons/vsc'
import { useHistory } from 'react-router-dom'
import { useAuthContext } from '../../../../context/AuthProvider/index'
import { useMeQuery } from '../../../../generated/graphql'
import { useAppContext } from '../../../../context/AppProvider/index'
import { LEAVE } from 'lib/websockets/constants'

type ProfileButtonProps = {
  buttonTrigger?: React.ReactNode
}

const ProfileButton: React.FC<ProfileButtonProps> = ({ buttonTrigger }) => {
  const history = useHistory()
  const { data, loading } = useMeQuery()
  const { logout } = useAuthContext()
  const { isLive, drawerOpen2 } = useAppContext()
  const user = data?.myUser
  const handleLogout = () => {
    // The socket may never have been opened (e.g. the connection failed), so
    // signing out must not depend on it existing.
    const socket = getSocket()
    logout && logout()
    socket?.emit(LEAVE, { userId: user?.id })
    socket?.disconnect()
    history.push('/')
  }
  const fullName = `${user?.attributes?.firstName} ${user?.attributes?.lastName}`

  return (
    <Menu placement={drawerOpen2 ? 'auto' : 'left-start'}>
      <MenuButton p={1} mx={1} borderRadius="50%">
        {buttonTrigger ? (
          buttonTrigger
        ) : (
          <Center _focus={{ boxShadow: 'outline' }}>
            {drawerOpen2 && (
              <Flex direction="column" align="flex-end" mx={3}>
                <Skeleton isLoaded={!loading}>
                  <Heading as="h6" isTruncated fontSize="xs">
                    {fullName}
                  </Heading>
                </Skeleton>
                <Skeleton isLoaded={!loading}>
                  <Text isTruncated fontSize="x-small" color="gray.500">
                    {user?.attributes?.company?.data?.attributes?.name}
                  </Text>
                </Skeleton>
              </Flex>
            )}
            <Skeleton isLoaded={!loading} rounded="0">
              <Avatar
                size="sm"
                name={`${user?.attributes?.firstName} ${user?.attributes?.lastName}`}
              >
                <AvatarBadge boxSize=".8rem" bg={isLive ? 'gray.600' : 'red.300'} />
              </Avatar>
            </Skeleton>
          </Center>
        )}
      </MenuButton>

      <MenuList textAlign="left" overflow="hidden" rounded="0" p={0}>
        <>
          <MenuGroup>
            <MenuItem onClick={() => history.push('/auth/settings')}>
              <Center py={2}>
                <Avatar size="sm" name={fullName} mr={2}>
                  <AvatarBadge boxSize="1.25em" bg="gray.900" />
                </Avatar>
                <Flex direction="column">
                  <Heading as="h4" fontSize="md">
                    {fullName}
                  </Heading>
                  <Text color="gray.500" fontSize="x-small">
                    {user?.attributes?.email}
                  </Text>
                </Flex>
              </Center>
            </MenuItem>
          </MenuGroup>

          {/* <MenuItem fontSize="xs" icon={<FcQuestions />} onClick={() => history.push('/auth/help')}>
            Help
          </MenuItem> */}
          <MenuItem fontSize="xs" color="red.600" icon={<VscSignOut />} onClick={handleLogout}>
            Logout
          </MenuItem>
        </>
      </MenuList>
    </Menu>
  )
}

export default ProfileButton
